module.exports = __webpack_public_path__ + "static/img/icon_bgjdk.2abbf376.png";